import type { ReactNode } from 'react';
import { create } from 'zustand';

export interface ConfirmationModalProps {
    title?: ReactNode;
    content?: ReactNode;
    confirmButtonText: string;
    cancelButtonText: string;
    onConfirm: () => void | Promise<void>;
    onCancel?: () => void;
}

interface ConfirmationModalStore {
    isOpen: boolean;
    modalProps: ConfirmationModalProps | null;
    openConfirmationModal: (props: ConfirmationModalProps) => void;
    closeConfirmationModal: () => void;
}

export const useConfirmationModalStore = create<ConfirmationModalStore>(set => ({
    isOpen: false,
    modalProps: null,
    openConfirmationModal: (modalProps: ConfirmationModalProps) => set({ isOpen: true, modalProps }),
    closeConfirmationModal: () => set({ isOpen: false, modalProps: null }),
}));

export const useConfirmationModal = () => {
    const { isOpen, openConfirmationModal } = useConfirmationModalStore();

    return {
        openConfirmationModal,
        isOpen,
    };
};
